import { API_URL } from "config";
import { Http } from "util/https";
import { WcInfoList } from "features/wc/types";

/**
 * トイレの最新混雑状況呼び出し
 * @param building_id 建物ID
 */
export async function getWcInfo(building_id: number) {
  const http = Http.default.alterAuth({});
  const url = `${API_URL}/status/${building_id}/latest`;

  const res = await http.get<WcInfoList>(url);
  return res.data;
}

export default getWcInfo;
